export function prepaymentListConfig(getMoney, selectPersonClick) {
    return {
        menuType: "button",
        addBtn: false,
        menuWidth: 120,
        menuAlign: "center",
        card: true,
        menu: false,
        delBtn: false,
        editBtn: false,
        align: "center",
        searchMenuSpan: 8,
        columnBtn: false,
        searchBtn: true,
        index: true,
        indexLabel: "序号",
        refreshBtn: true,
        // showSummary: true,
        selection: true,
        selectionWidth: 45,
        searchShow: false,
        border:true,
        column: [
        //     {
        //     label: '保理合同',
        //     hide: true,
        //     display: false,
        //     search: true,
        //     prop: 'searchName',
        //     placeholder: '请输入项目名称/合同名称'
        // },
        {
            label: '保理合同',
            searchPlaceholder: "请输入保理合同",
            placeholder: '请输入保理合同',
            slot: true,
            search: true,
            searchslot: true,
            prop: "contractName",
            width: 180,
        }, {
            label: '审批状态',
            prop: 'auditStatusStr',
        }, {
            label: '项目名称',
            searchPlaceholder: "请输入项目名称",
            placeholder: '请输入项目名称',
            prop: "projectName",
            // overHidden: true,
            search: true,
            width: '300'
        }, {
            label: "客户名称",
            placeholder: "请输入客户名称",
            prop: "sellerCustName",
            width: "150",
            overHidden: true
        }, {
            label: "归还总金额（元）",
            placeholder: "请输入客户名称",
            prop: "totalAmount",
            width: "120",
            overHidden: true
        },
        {
            label: '审批状态',
            prop: 'auditStatus',
            span: 12,
            hide: true,
            search: true,
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=project_build_state",
            props: {
              label: "dictValue",
              value: "dictKey"
            }
        }, {
            label: '业务主办',
            prop: 'managerUserStr',         
        }, {
            label: '业务协办',
            prop: 'assistUserStr'
        }, {
            label: '所属部门',
            prop: 'managerDeptStr',
            width: "230"
        }, {
            label: '创建时间',
            width: '180',
            prop: 'createTime',
            overHidden: true
        }, {
            label: '核销状态',
            prop: 'isWriteoff',
            hide: true,
            search: true,
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=factoring_writeoff",
            props: {
              label: "dictValue",
              value: "dictKey"
            }            
        },{
            label: '核销状态',
            prop: 'isWriteoffStr'
        }, {
            label: '核销人员',
            prop: 'writeoffUserStr'
        }, {
            label: '核销时间',
            width: '180',
            prop: 'writeoffTime',
            overHidden: true
        }]
    }
}

export function addPrepaymentConfig(getMoney, selectPersonClick) {
    return {
        labelWidth: 130,
        emptyBtn: false,
        submitBtn: false,
        column: [
            {
                label: '项目名称',
                prop: "projectName",
                formslot: true,
                rules: [{
                    required: true,
                    message: "请选择项目",
                    trigger: "change"
                }]
            }, {
                label: '保理合同',
                prop: "contractName",
                formslot: true,
                rules: [{
                    required: true,
                    message: "请选择合同",
                    trigger: "change"
                }]
            }, {
                label: '客户名称',
                prop: "sellerCustName",
                disabled: true,
            },
            // {
            //     label: '内部收益率',
            //     prop: "xirrStr",
            //     disabled: true,
            // },
            {
                label: '业务主办',
                prop: "managerUserName",
                disabled: true,
            }, {
                label: '业务协办',
                prop: "assistUserName",
                disabled: true,
            }
        ]
    }
}

export function extraPrepaymentConfig(getRepaymentInfo) {
    return {
        labelWidth: 130,
        emptyBtn: false,
        submitBtn: false,
        column: [
            {
                label: '预计还款时间',
                prop: "prepaymentDate",
                type: 'date',
                format:'yyyy-MM-dd',
                valueFormat:'yyyy-MM-dd',
                change: ({ value }) => {
                    getRepaymentInfo(value)
                },
                rules: [{
                    required: true,
                    message: "请选择预计还款时间",
                    trigger: "change"
                }]
            },{
                label: '测算归还本金',
                prop: "calcPrincipal",
                disabled: true,
                append: '元'
            },{
                label: '实际归还本金',
                prop: "principal",
                append: '元',
                rules: [{
                    required: true,
                    message: "请输入实际归还本金",
                    trigger: "blur"
                }]
            },{
                label: '本金大写金额',
                prop: "principalStr",
                append: '元',
                disabled: true,
            },{
                label: '测算归还利息',
                prop: "calcInterest",
                append: '元',
                disabled: true,
            },{
                label: '实际归还利息',
                prop: "interest",
                append: '元',
                rules: [{
                    required: true,
                    message: "请输入实际归还本金",
                    trigger: "blur"
                }]
            },{
                label: '利息大写金额',
                prop: "interestStr",
                append: '元',
                disabled: true,
            },{
                label: '保证金抵扣金额',
                prop: "depositDeductionAmount",
                append: '元',
                rules: [{
                    required: true,
                    message: "请输入保证金抵扣金额",
                    trigger: "blur"
                }]
            },{
                label: '实际归还总金额',
                prop: "realReturn",
                append: '元',
                disabled: true                
            }
        ]
    }
}

export function addFormConfig() {
    return [
        {
            label: '项目名称',
            prop: "projectName",
            span: 12
        },{
            label: '保理合同',
            prop: "contractName",
            span: 12
        },{
            label: '客户名称',
            prop: "sellerCustName",
            span: 12
        },
        // {
        //     label: '内部收益率',
        //     prop: "xirrStr",
        //     span: 12
        // },
        {
            label: '业务主办',
            prop: "managerUserName",
            span: 12
        },{
            label: '业务协办',
            prop: "assistUserName",
            span: 12
        },
    ]
}

export function extraFormConfig() {
    return [
        {
            label: '预计还款日期',
            prop: "prepaymentDate",         
            span: 12
        },{
            label: '测算归还本金',
            prop: "calcPrincipal",
            unit: '元',
            span: 12
        },{
            label: '实际归还本金',
            prop: "principalChange",
            unit: '元',
            span: 12
        },{
            label: '本金大写金额',
            prop: "principalStr",
            span: 12
        },{
            label: '测算归还利息',
            prop: "calcInterest",
            unit: '元',
            span: 12
        },{
            label: '实际归还利息',
            prop: "interestChange",
            unit: '元',
            span: 12
        },{
            label: '利息大写金额',
            prop: "interestStr",
            span: 12
        },{
            label: '保证金抵扣金额',
            prop: "depositDeductionAmountStr",
            unit: '元',
            span: 12
        },{
            label: '实际归还总金额',
            prop: "realReturnStr",
            unit: '元',
            span: 12
        },
    ]
}
